export function buildBehavior({ properties, dependencies, update, init, beforeUpdate, cleanup, }) {
    const behavior = {
        properties,
        dependencies,
        update(entity, dt) {
            if (update) {
                update(entity, dt);
            }
        },
        beforeUpdate(entity) {
            if (beforeUpdate) {
                beforeUpdate(entity);
            }
        },
        init(entity) {
            if (init) {
                init(entity);
            }
        },
        cleanup(entity) {
            if (cleanup) {
                cleanup(entity);
            }
        },
    };
    return behavior;
}
